/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import { showToast } from '../../showTost';
import Slider from "react-slick";
import { useTranslation } from 'react-i18next';
import Payment from '../../PaymentGetaway/Payment';
import { uid } from 'uid';
import { useNavigate } from 'react-router-dom';
import { collection, deleteDoc, doc, getDocs } from 'firebase/firestore';
import { db } from '../../Firebase/firebase';
const CustomPrevArrow = ({ onClick }) => (
    <div
        onClick={onClick}
        className="bg-white p-[7px] rounded-[50px] absolute z-10 right-[45px] -top-[30px] transform -translate-y-1/2 cursor-pointer">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.7501 12C21.7501 12.414 21.4141 12.75 21.0001 12.75H4.81115L10.5311 18.47C10.8241 18.763 10.8241 19.238 10.5311 19.531C10.3851 19.677 10.1931 19.751 10.0011 19.751C9.80909 19.751 9.61706 19.678 9.47106 19.531L2.47106 12.531C2.40206 12.462 2.3472 12.3791 2.3092 12.2871C2.2332 12.1041 2.2332 11.8971 2.3092 11.7141C2.3472 11.6221 2.40206 11.539 2.47106 11.47L9.47106 4.46999C9.76406 4.17699 10.2391 4.17699 10.5321 4.46999C10.8251 4.76299 10.8251 5.23803 10.5321 5.53103L4.81213 11.251H21.0001C21.4141 11.25 21.7501 11.586 21.7501 12Z" fill="#25314C" />
        </svg>
    </div>
);

const CustomNextArrow = ({ onClick }) => (
    <div
        onClick={onClick}
        className="bg-white p-[7px] rounded-[50px] absolute z-10 right-[0px] -top-[30px] transform -translate-y-1/2 cursor-pointer">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.6919 12.2871C21.6539 12.3791 21.599 12.462 21.53 12.531L14.53 19.531C14.384 19.677 14.192 19.751 14 19.751C13.808 19.751 13.616 19.678 13.47 19.531C13.177 19.238 13.177 18.763 13.47 18.47L19.1899 12.75H3C2.586 12.75 2.25 12.414 2.25 12C2.25 11.586 2.586 11.25 3 11.25H19.189L13.469 5.53005C13.176 5.23705 13.176 4.76202 13.469 4.46902C13.762 4.17602 14.237 4.17602 14.53 4.46902L21.53 11.469C21.599 11.538 21.6539 11.6209 21.6919 11.7129C21.7679 11.8969 21.7679 12.1031 21.6919 12.2871Z" fill="#25314C" />
        </svg>
    </div>
);

const MyBooking = () => {

    const { t } = useTranslation();
    const { BaseUrl, setPaymentRes, paymentRes } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [bookinglist, setBookingList] = useState([]);
    const [detail, setDetail] = useState("");
    const [iscancel, setIsCancel] = useState("");
    const [apiloading, setApiLoding] = useState(false);
    const [reshedullod, setReshedulLod] = useState(false);
    const [isreshedule, setIsReshedule] = useState("");
    const [datelist, setDateList] = useState([]);
    const [selectdate, setSelectDate] = useState("");
    const [timelist, setTimeList] = useState([]);
    const [copytimelist, setCopyTimeList] = useState([]);
    const [selecttime, setSelectTime] = useState("");
    const [ispayment, setIsPayment] = useState(false);
    const [bookingdata, setBookingData] = useState("");
    const [isRating, setIsRating] = useState("");
    const [orderrating, setOrderRating] = useState(1);
    const [ratingtext, setRatingText] = useState("");
    const [ratingTitle, setRatingTitle] = useState("");
    const [serviceId, setServiceId] = useState("");


    const navigate = useNavigate();
    const Currency = secureLocalStorage.getItem("currency");

    const settings = {
        dots: false,
        infinite: false,
        arrows: true,
        speed: 500,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            { breakpoint: 1445, settings: { slidesToShow: 6 }, },
            { breakpoint: 1310, settings: { slidesToShow: 5 }, },
            { breakpoint: 1145, settings: { slidesToShow: 4 }, },
            { breakpoint: 580, settings: { slidesToShow: 5 }, },
            { breakpoint: 430, settings: { slidesToShow: 4 }, },
        ],
    };

    useEffect(() => {
        handleFetchData();
        const PaymentRes = sessionStorage.getItem("Paymentstatus");
        if (PaymentRes) {
            if (PaymentRes === "PaymentDone") {
                setPaymentRes("PaymentDone");
            } else {
                setPaymentRes("PaymentFail");
            }
        }

    }, []);

    useEffect(() => {
        if (!paymentRes) return;
        if (paymentRes === "PaymentDone") {
            handleBooking();
        } else {
            showToast({ title: t("Payment faild !!"), id: "error" });
            setPaymentRes("");
            sessionStorage.removeItem("Paymentstatus");
            secureLocalStorage.removeItem("Bookingdata");
        }
    }, [paymentRes]);


    const handleFetchData = () => {
        const uid = secureLocalStorage.getItem("Userid");
        axios.post(`${BaseUrl}tcapi/s_order_list.php`, { uid })
            .then((res) => {
                setBookingList(res.data.customerorderlist);
                setLoading(false);
            })
            .catch((error) => {
                console.error("s_order_list.php", error);
            });
    }

    const handleGetTimeSlot = (item) => {
        const uid = secureLocalStorage.getItem("Userid");
        setReshedulLod(true);
        setIsReshedule(item.order_id);
        axios.post(`${BaseUrl}tcapi/s_timeslot.php`, { uid, cid: item.category_id })
            .then((res) => {
                const { TimeslotData } = res.data;
                setDateList(TimeslotData[0].days);
                handleSelectDate(TimeslotData[0].days[0], TimeslotData[0].tslot);
                setCopyTimeList(TimeslotData[0].tslot);
                setReshedulLod(false);
            })
            .catch((error) => {
                console.error("s_timeslot.php", error);
            })
    }

    const formatCustomDate = (dateStr) => {
        const date = new Date(dateStr);
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        return `${month} ${day < 10 ? `0${day}` : day}, ${year}`
    };

    const handleCancleBooking = () => {
        const uid = secureLocalStorage.getItem("Userid");
        setApiLoding(true);
        axios.post(`${BaseUrl}tcapi/s_order_cancle.php`, { uid, oid: iscancel })
            .then((res) => {
                const Toastid = res.data.ResponseCode === "200" ? "success" : "error";
                showToast({ title: res.data.ResponseMsg, id: Toastid });
                setApiLoding(false);
                handleFetchData();
                setIsCancel("");
            })
            .catch((error) => {
                console.error("s_order_cancle.php", error);
            })
    }

    const handleSelectDate = (item, TimeList) => {

        setSelectDate(item);

        const CurrentDate = new Date()
        const dayName = CurrentDate.toLocaleDateString('en-US', { weekday: 'short' });
        const dayNumber = CurrentDate.getDate();
        const GetDate = `${dayName} ${dayNumber}`

        if (item === GetDate) {
            const currentHours = CurrentDate.getHours();
            const currentMinutes = CurrentDate.getMinutes();
            const currentTimeDate = new Date();

            currentTimeDate.setHours(currentHours, currentMinutes, 0, 0);

            const filteredTimes = TimeList.filter(timeStr => {
                const time24 = new Date();
                const [time, modifier] = timeStr.split(" ");
                let [hours, minutes] = time.split(":").map(Number);

                if (modifier.toLowerCase() === "pm" && hours !== 12) {
                    hours += 12;
                } else if (modifier.toLowerCase() === "am" && hours === 12) {
                    hours = 0;
                }

                time24.setHours(hours, minutes, 0, 0);
                return time24 >= currentTimeDate;
            });

            setTimeList(filteredTimes);
            setSelectTime(filteredTimes[0]);
        } else {
            setSelectTime(copytimelist[0]);
            setTimeList(copytimelist);
        }
    }

    const handleReshedule = () => {

        if (!selectdate || !selecttime) {
            showToast({ title: t("Please select date and time !!"), id: "info" });
            return;
        }

        const uid = secureLocalStorage.getItem("Userid");

        const ApiData = {
            uid, oid: isreshedule,
            time: selecttime,
            date: selectdate
        }

        setApiLoding(true);

        axios.post(`${BaseUrl}tcapi/s_reschedule.php`, ApiData)
            .then((res) => {
                const Toastid = res.data.ResponseCode === "200" ? "success" : "error";
                showToast({ title: res.data.ResponseMsg, id: Toastid });
                setApiLoding(false);
                setIsReshedule("");
                setSelectDate("");
                setSelectTime("");
                handleFetchData();
            })
            .catch((error) => {
                console.error("s_reschedule.php", error);
            })
    }

    const handleProceedToPay = () => {
        const Userid = secureLocalStorage.getItem("Userid");

        const Data = {
            Userid,
            oid: detail.order_id,
            partner_id: detail?.partner_id,
        }

        setBookingData(Data);
        setIsPayment(true);
        secureLocalStorage.setItem("page", "/bookings");
    }

    const handleBooking = () => {
        const t_id = sessionStorage.getItem("transactionid") || uid(10);
        const LocalData = secureLocalStorage.getItem("Bookingdata");
        if (LocalData) {
            const { oid, p_method_id, partner_id, extra_wall_amt } = JSON.parse(LocalData);

            const ApiData = {
                pay_id: p_method_id,
                extra_wall_amt,
                t_id,
                oid,
            }
            axios.post(`${BaseUrl}tcapi/order_complete.php`, ApiData)
                .then((res) => {
                    const Toastid = res.data.ResponseCode === "200" ? "success" : "error";
                    showToast({ title: res.data.ResponseMsg, id: Toastid });
                    if (res.data.ResponseCode === "200") {
                        sessionStorage.removeItem("transactionid");
                        secureLocalStorage.removeItem("Bookingdata");
                        setDetail("");
                        setPaymentRes("");
                        setIsPayment(false);
                        handleDeleteChat(partner_id);
                        handleFetchData();
                    }
                })
                .catch((error) => {
                    console.error("order_complete.php", error);
                });
        }
    }

    const handleRating = () => {
        const Userid = secureLocalStorage.getItem("Userid");
        let ApiData;
        let Url;

        if (ratingTitle) {
            Url = "service_rate.php";
            ApiData = {
                uid: Userid,
                service_id: serviceId,
                order_id: isRating,
                total_rate: orderrating,
                rate_desc: ratingtext || "",
            }
        } else {
            Url = "rate_update.php";
            ApiData = {
                uid: Userid,
                order_id: isRating,
                total_rate: orderrating,
                rate_desc: ratingtext || "",
            }
        }


        setApiLoding("Rating");
        axios.post(`${BaseUrl}tcapi/${Url}`, ApiData)
            .then((res) => {
                const Toastid = res.data.ResponseCode === "200" ? "success" : "error";
                showToast({ title: res.data.ResponseMsg, id: Toastid });
                setIsRating("");
                setOrderRating(1);
                setRatingText("");
                setRatingTitle("");
                setServiceId("");
                setApiLoding("");
                setDetail("");
                handleFetchData();
            })
            .catch((error) => {
                console.error("rate_update", error);
            });
    }

    const handleGoToChat = () => {
        navigate("/chat", { state: { name: detail.partner_name, id: detail?.partner_id } });
    }

    const handleDeleteChat = async (partner_id) => {
        const Userid = secureLocalStorage.getItem("Userid");
        const JoinIds = `${partner_id}_${Userid}`;
        const messagesRef = collection(
            db,
            "UClapProChat_rooms",
            JoinIds,
            "message"
        );
        const snapshot = await getDocs(messagesRef);
        const deletePromises = snapshot.docs.map((docu) =>
            deleteDoc(docu.ref)
        );
        await Promise.all(deletePromises);
        const chatDocRef = doc(db, "UClapProChat_rooms", JoinIds);
        await deleteDoc(chatDocRef);
    };

    return (
        <div className="booking_page">
            {loading
                ? <div className="w-full h-[calc(100vh-85px)] bg-white z-[777] fixed flex items-center justify-center">
                    <div className="loader"></div>
                </div>
                :
                <div className="width_container">

                    <div className="leading-[35px]">
                        <h1 className="title">{t("Bookings")}</h1>
                        <p className="font-[500] text-[17px] text-gray-500">{t("You added")} {bookinglist?.length || "0"} {t("items to booking")}</p>
                    </div>

                    <div className="mt-[20px] flex flex-wrap items-stretch gap-[20px]">
                        {bookinglist?.map((item, index) => {
                            const IsColor = item?.Order_Status === "Pending" ? "text-yellow-500" : item?.Order_Status === "Processing" ? "text-blue-500" : item?.Order_Status === "Completed" ? "text-[#22C55E]" : item.Order_Status === "Cancelled" && "text-red-500";
                            return <div key={index} onClick={() => setDetail(item)} className="card_box">
                                <div className="flex items-center gap-[10px] justify-between">
                                    <div className="font-[500] text-[16px] text-gray-800 leading-[18px] overflow-hidden">
                                        <h1>{t("Booking id")} : {item.order_id}</h1>
                                        <p className="whitespace-nowrap overflow-hidden overflow-ellipsis">{t("Booking date")} : {formatCustomDate(item.order_date)}</p>
                                    </div>
                                    <span className={`${IsColor} font-[500] text-[16px]`}>{item.Order_Status}</span>
                                </div>
                                <div className="my-[10px]">
                                    {item.Order_Product_Data.map((item, index) => {
                                        if (index < 2) {
                                            return <div key={index} className="flex items-center gap-[10px] py-[2px]">
                                                <span className="whitespace-nowrap bg-gray-200 text-[13px] font-[500] px-[8px] rounded-[5px]">{item.Product_quantity} X</span>
                                                <p className="whitespace-nowrap overflow-hidden overflow-ellipsis text-[15px]">{item.Product_name}</p>
                                            </div>
                                        }
                                    })}
                                    {item.Order_Product_Data.length > 2 && <span className="text-[13px] font-[500] underline text-gray-500">& {item.Order_Product_Data.length - 2} {t("more")}</span>}
                                </div>

                                <div>
                                    <div className="border-t-[1px]"></div>
                                    {item.Order_Status === "Pending" && <div className="flex items-center gap-[10px]">
                                        <button onClick={(e) => { e.stopPropagation(); handleGetTimeSlot(item); }} className="w-full bg-[--color] text-white font-[600] py-[8px] mt-[10px] rounded-[10px] text-[17px]">{t("Reschedule")}</button>
                                        <button onClick={(e) => { e.stopPropagation(); setIsCancel(item.order_id); }} className="button bg-[--bgcolor] rounded-[10px]">{t("Cancel")}</button>
                                    </div>}
                                    {(item.Order_Status === "Completed" && item.is_rate == "0") && <button onClick={(e) => { e.stopPropagation(); setIsRating(item.order_id); }} className="button bg-[--bgcolor] rounded-[10px]">{t("Partner Rating")}</button>}

                                    {item.is_rate == "1" && <div className="py-[5px] mt-[5px]">
                                        <div className="flex items-center justify-center gap-[5px]">
                                            {["1", "2", "3", "4", "5"].map((star) => {
                                                const IsFill = star <= item.total_rate;
                                                if (IsFill) {
                                                    return (<svg key={star} width="20" height="20" className="text-yellow-600" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M12.962 4.59601L14.904 8.513C15.05 8.808 15.332 9.01202 15.659 9.05902L20.1419 9.70697C20.9639 9.82597 21.292 10.834 20.697 11.412L17.456 14.557C17.219 14.787 17.111 15.118 17.167 15.443L17.9079 19.747C18.0579 20.62 17.1409 21.286 16.3549 20.875L12.467 18.84C12.175 18.687 11.827 18.687 11.536 18.84L7.65096 20.873C6.86396 21.285 5.94393 20.618 6.09493 19.743L6.83602 15.443C6.89202 15.118 6.78396 14.787 6.54696 14.557L3.30599 11.412C2.70999 10.834 3.03792 9.82597 3.86092 9.70697L8.34395 9.05902C8.66995 9.01202 8.95196 8.808 9.09896 8.513L11.041 4.59601C11.432 3.80101 12.568 3.80101 12.962 4.59601Z" fill="currentColor" />
                                                    </svg>)
                                                } else {
                                                    return (<svg key={star} width="20" height="20" className="text-yellow-600" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M16.8541 21.75C16.5651 21.75 16.275 21.681 16.006 21.54L12.1181 19.505C12.0441 19.466 11.956 19.466 11.882 19.505L7.997 21.538C7.378 21.862 6.6421 21.808 6.0761 21.396C5.5131 20.985 5.23508 20.304 5.35308 19.617L6.09405 15.316C6.10805 15.235 6.081 15.153 6.023 15.096L2.78203 11.95C2.30103 11.483 2.13009 10.796 2.33709 10.157C2.54409 9.51798 3.08601 9.06099 3.75201 8.96399L8.23406 8.31598C8.31606 8.30398 8.38605 8.25299 8.42205 8.17999L10.365 4.26202C10.675 3.63702 11.3011 3.24902 11.9991 3.24902C12.6971 3.24902 13.3231 3.63702 13.6331 4.26202L15.575 8.17902C15.612 8.25302 15.6821 8.30398 15.7641 8.31598L20.246 8.96399C20.912 9.05999 21.4541 9.51698 21.6611 10.157C21.8681 10.796 21.697 11.483 21.216 11.95L17.976 15.095C17.916 15.153 17.8901 15.235 17.9041 15.316L18.6451 19.619C18.7631 20.305 18.487 20.986 17.923 21.396C17.605 21.631 17.2301 21.75 16.8541 21.75ZM12.0001 17.976C12.2791 17.976 12.559 18.042 12.813 18.175L16.7011 20.21C16.8561 20.292 16.982 20.229 17.042 20.185C17.102 20.142 17.197 20.043 17.168 19.875L16.4271 15.571C16.3291 15.001 16.519 14.421 16.934 14.019L20.173 10.875C20.27 10.781 20.254 10.675 20.236 10.621C20.218 10.566 20.168 10.47 20.033 10.45L15.5511 9.802C14.9801 9.72 14.4871 9.36201 14.2321 8.84601L12.2911 4.92999C12.2141 4.77399 12.076 4.75098 12.001 4.75098C11.926 4.75098 11.7881 4.77399 11.7111 4.92999L9.7691 8.84698C9.5151 9.36198 9.0221 9.72 8.4511 9.802L3.96905 10.45C3.83405 10.47 3.78304 10.565 3.76604 10.621C3.74804 10.676 3.73303 10.781 3.82903 10.875L7.06902 14.02C7.48302 14.421 7.673 15.001 7.575 15.571L6.83404 19.872C6.80504 20.041 6.90111 20.14 6.96111 20.184C7.02311 20.228 7.14501 20.29 7.30401 20.209L11.189 18.176C11.441 18.043 11.7211 17.976 12.0001 17.976Z" fill="currentColor" />
                                                    </svg>)
                                                }
                                            })}
                                        </div>
                                    </div>}
                                    <p className="font-[500] text-gray-600 mt-[5px] text-[14px]">• {t("Bill Total")} : <span className="text-black">{Currency + item.Order_Total}</span></p>
                                </div>

                            </div>
                        })}
                    </div>

                </div>}

            {detail && <div onClick={() => setDetail("")} className="model items-center">
                <div onClick={(e) => e.stopPropagation()} className="details_box scroll_container">

                    <div className="px-[20px] py-[15px] bg-white sticky top-0">
                        <div className="flex items-center gap-[10px]">
                            <button onClick={() => setDetail("")}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20.7501 12C20.7501 12.414 20.4141 12.75 20.0001 12.75H5.81115L8.53112 15.47C8.82412 15.763 8.82412 16.238 8.53112 16.531C8.38512 16.677 8.19309 16.751 8.00109 16.751C7.80909 16.751 7.61706 16.678 7.47106 16.531L3.47106 12.531C3.40206 12.462 3.3472 12.3791 3.3092 12.2871C3.2332 12.1041 3.2332 11.8971 3.3092 11.7141C3.3472 11.6221 3.40206 11.539 3.47106 11.47L7.47106 7.46999C7.76406 7.17699 8.2391 7.17699 8.5321 7.46999C8.8251 7.76299 8.8251 8.23803 8.5321 8.53103L5.81213 11.251H20.0001C20.4141 11.25 20.7501 11.586 20.7501 12Z" fill="#25314C"></path>
                                </svg>
                            </button>
                            <div className="leading-[18px]">
                                <h1 className="font-[600] text-[16px]">{t("Booking")} #{detail.order_id}</h1>
                                <p className="font-[600] text-[14px] text-gray-600">{detail.Order_Status} | On {detail.order_dateslot} At {detail.order_time}</p>
                            </div>
                        </div>
                    </div>

                    <div className="px-[20px] py-[5px]">
                        <h1 className="font-[600] text-[16px] text-gray-600 mb-[5px]">{t("Your Services")}</h1>

                        <div className="bg-white px-[10px] py-[5px] rounded-[10px]">
                            {detail.Order_Product_Data?.map((item, index) => {
                                return <div key={index} className="py-[3px] flex items-center justify-between gap-[10px]">
                                    <h1 className="text-[15px] text-gray-800 whitespace-nowrap overflow-hidden overflow-ellipsis font-[500]">{item.Product_quantity}x {item.Product_name}</h1>
                                    <span className="font-[500] text-gray-800 text-[15px]">{Currency + item.Product_total}</span>
                                    {detail.Order_Status === "Completed" && <button disabled={item.is_rate == "1"} onClick={() => { setIsRating(detail.order_id); setRatingTitle(item.Product_name); setServiceId(item.service_id) }} className={`border ${item.is_rate == "0" ? "border-black text-black" : "border-gray-400 text-gray-400"} px-[10px] py-[2px] text-[14px] rounded-[50px]`}>{t("Review")}</button>}
                                </div>
                            })}
                        </div>
                    </div>

                    <div className="px-[20px] py-[5px]">
                        <h1 className="font-[600] text-[16px] text-gray-600 mb-[5px]">{t("Addon List")}</h1>

                        <div className="bg-white px-[10px] py-[5px] rounded-[10px]">
                            {detail.add_on_data?.map((item, index) => {
                                return <div key={index} className="py-[3px] flex items-center justify-between gap-[10px]">
                                    <h1 className="text-[15px] text-gray-800 whitespace-nowrap overflow-hidden overflow-ellipsis font-[500]">{item.title}</h1>
                                    <span className="font-[500] text-gray-800 text-[15px]">{Currency + item.price}</span>
                                </div>
                            })}
                        </div>
                    </div>

                    <div className="px-[20px] py-[5px]">
                        <h1 className="font-[600] text-[16px] text-gray-600 mb-[5px]">{t("Bill Summary")}</h1>
                        <div className="bg-white px-[10px] py-[5px] rounded-[10px]">
                            <div className="text-[15px] text-gray-800 font-[500] flex items-center justify-between gap-[10px] py-[3px]">
                                <h1>{t("Time Slot")}</h1>
                                <span>{detail.order_dateslot} - {detail.order_time}</span>
                            </div>
                            <div className="text-[15px] text-gray-800 font-[500] flex items-center justify-between gap-[10px] py-[3px]">
                                <h1>{t("SubTotal")}</h1>
                                <span>{Currency + detail.Order_SubTotal}</span>
                            </div>
                            <div className="text-[15px] text-gray-800 font-[500] flex items-center justify-between gap-[10px] py-[3px]">
                                <h1>{t("Addon Total")}</h1>
                                <span>{Currency + detail.add_total}</span>
                            </div>
                            <div className="border-b-[2px] border-dashed mt-[5px]"></div>
                            <div className="text-[15px] text-gray-800 font-[500] flex items-center justify-between gap-[10px] py-[3px] mt-[5px]">
                                <h1>{t("Total")}</h1>
                                <span>{Currency + detail.Order_Total}</span>
                            </div>
                        </div>
                    </div>

                    {(detail.Order_Status === "Processing" || detail.Order_Status === "Completed") && <div className="px-[20px] py-[5px]">
                        <h1 className="font-[600] text-[16px] text-gray-600 mb-[5px]">{t("Service provider information")}</h1>
                        <div className="bg-white px-[10px] py-[5px] rounded-[10px] flex items-center justify-between gap-[15px]">
                            <div className="flex items-center gap-[15px]">
                                <img src={BaseUrl + detail.partner_img} className='w-[80px] h-[60px] object-cover rounded-[10px]' alt="partner_img" />
                                <div className="text-[15px] text-gray-800 font-[500]">
                                    <h1>{detail.partner_name}</h1>
                                    <p>{detail.partner_mobile}</p>
                                </div>
                            </div>
                            {detail.Order_Status == "Processing" && <button onClick={handleGoToChat} className="bg-[--bgcolor] p-[5px] rounded-[10px]">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.85693 21.75C3.71193 21.75 3.57111 21.748 3.43311 21.743C2.93311 21.731 2.49497 21.411 2.32397 20.928C2.15197 20.442 2.29408 19.9131 2.68408 19.5811C3.61608 18.8291 3.98892 17.997 4.13892 17.426C2.90192 15.947 2.24902 14.08 2.24902 12.001C2.24902 6.84798 6.25902 3.25 11.999 3.25C17.739 3.25 21.749 6.84898 21.749 12.001C21.749 17.153 17.739 20.752 11.999 20.752C10.812 20.752 9.67398 20.591 8.60498 20.2729C7.24198 21.4599 5.36393 21.75 3.85693 21.75ZM3.47803 20.243C3.48003 20.243 3.48189 20.243 3.48389 20.243C3.48089 20.244 3.47903 20.244 3.47803 20.243ZM12 4.75C7.143 4.75 3.75 7.73198 3.75 12.001C3.75 13.837 4.35498 15.463 5.50098 16.703C5.65598 16.871 5.72692 17.101 5.69092 17.328C5.52292 18.399 4.99511 19.412 4.18311 20.243C5.34311 20.201 6.90304 19.934 7.86304 18.91C8.06404 18.694 8.37603 18.617 8.65503 18.714C9.69003 19.072 10.815 19.2531 12 19.2531C16.857 19.2531 20.25 16.271 20.25 12.002C20.25 7.73295 16.857 4.75 12 4.75ZM13.02 12C13.02 11.448 12.573 11 12.02 11H12.01C11.458 11 11.0149 11.448 11.0149 12C11.0149 12.552 11.468 13 12.02 13C12.572 13 13.02 12.552 13.02 12ZM17.02 12C17.02 11.448 16.573 11 16.02 11H16.01C15.458 11 15.0149 11.448 15.0149 12C15.0149 12.552 15.468 13 16.02 13C16.572 13 17.02 12.552 17.02 12ZM9.02002 12C9.02002 11.448 8.57302 11 8.02002 11H8.01001C7.45801 11 7.01489 11.448 7.01489 12C7.01489 12.552 7.46802 13 8.02002 13C8.57202 13 9.02002 12.552 9.02002 12Z" fill="white" />
                                </svg>
                            </button>}
                        </div>
                    </div>}

                    <div className="px-[20px] py-[5px]">
                        <h1 className="font-[600] text-[16px] text-gray-600 mb-[5px]">{t("Booking Details")}</h1>

                        <div className="bg-white px-[10px] py-[5px] rounded-[10px]">

                            <div className="text-[15px] text-gray-800 font-[500] flex items-center justify-between gap-[10px] py-[3px]">
                                <h1>{t("Payment Method")}</h1>
                                <span>{detail.p_method_name}</span>
                            </div>

                            {detail.Order_Transaction_id !== "0" && <div className="text-[15px] text-gray-800 font-[500] flex items-center justify-between gap-[10px] py-[3px]">
                                <h1>{t("Transaction Id")}</h1>
                                <span>{detail.Order_Transaction_id}</span>
                            </div>}

                            <div className="text-[15px] text-gray-800 font-[500] flex items-center justify-between gap-[10px] py-[3px]">
                                <h1>{t("Amount Paid")}</h1>
                                <span>{Currency + detail.Order_Total}</span>
                            </div>

                            <div className="border-b-[2px] border-dashed mt-[5px]"></div>

                            <div className="text-[15px] text-gray-800 font-[500] flex items-center gap-[10px] py-[3px] mt-[5px]">
                                <svg width="24" height="24" className="min-w-[30px]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 2.25C7.175 2.25 3.25 6.175 3.25 11C3.25 16.118 7.94699 19.2199 11.055 21.2729L11.584 21.624C11.71 21.708 11.855 21.75 12 21.75C12.145 21.75 12.29 21.708 12.416 21.624L12.945 21.2729C16.053 19.2199 20.75 16.118 20.75 11C20.75 6.175 16.825 2.25 12 2.25ZM12.119 20.021L12 20.1001L11.881 20.021C8.871 18.033 4.75 15.311 4.75 11C4.75 7.002 8.002 3.75 12 3.75C15.998 3.75 19.25 7.002 19.25 11C19.25 15.311 15.128 18.034 12.119 20.021ZM12 7.75C10.208 7.75 8.75 9.208 8.75 11C8.75 12.792 10.208 14.25 12 14.25C13.792 14.25 15.25 12.792 15.25 11C15.25 9.208 13.792 7.75 12 7.75ZM12 12.75C11.035 12.75 10.25 11.965 10.25 11C10.25 10.035 11.035 9.25 12 9.25C12.965 9.25 13.75 10.035 13.75 11C13.75 11.965 12.965 12.75 12 12.75Z" fill="#25314C" />
                                </svg>
                                <p>{detail.customer_address}</p>
                            </div>
                            <div className="border-b-[2px] border-dashed mt-[5px]"></div>
                            <div className="text-[15px] text-gray-800 flex items-center gap-[10px] font-[500] py-[3px] mt-[5px]">
                                <svg width="20" height="20" className="w-[30px]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 1.25C6.072 1.25 1.25 6.072 1.25 12C1.25 17.928 6.072 22.75 12 22.75C17.928 22.75 22.75 17.928 22.75 12C22.75 6.072 17.928 1.25 12 1.25ZM12 21.25C6.899 21.25 2.75 17.101 2.75 12C2.75 6.899 6.899 2.75 12 2.75C17.101 2.75 21.25 6.899 21.25 12C21.25 17.101 17.101 21.25 12 21.25ZM15.53 14.47C15.823 14.763 15.823 15.238 15.53 15.531C15.384 15.677 15.192 15.751 15 15.751C14.808 15.751 14.616 15.678 14.47 15.531L11.47 12.531C11.329 12.39 11.25 12.199 11.25 12.001V7.00098C11.25 6.58698 11.586 6.25098 12 6.25098C12.414 6.25098 12.75 6.58698 12.75 7.00098V11.6899L15.53 14.47Z" fill="#25314C" />
                                </svg>
                                <p>{formatCustomDate(detail.order_date)}</p>
                            </div>
                        </div>
                    </div>

                    {detail.add_desc && <div className="px-[20px] py-[5px]">
                        <h1 className="font-[600] text-[16px] text-gray-600 mb-[5px]">{t("Extra Addon")}</h1>

                        <div className="bg-white px-[10px] py-[5px] rounded-[10px]">
                            <div className="text-[15px] text-gray-800 font-[500] flex items-center justify-between gap-[10px] py-[3px]">
                                <h1>{detail.add_desc}</h1>
                                <span>{Currency + detail.add_price}</span>
                            </div>

                            {detail.add_method_name && <div className="text-[15px] text-gray-800 font-[500] flex items-center justify-between gap-[10px] py-[3px]">
                                <h1>{t("Payment Method")}</h1>
                                <span>{detail.add_method_name}</span>
                            </div>}

                            {detail.add_tran_id && <div className="text-[15px] text-gray-800 font-[500] flex items-center justify-between gap-[10px] py-[3px]">
                                <h1>{t("Transaction Id")}</h1>
                                <span>{detail.add_tran_id}</span>
                            </div>}

                        </div>
                        {detail.Order_Status === "Processing" && <button onClick={handleProceedToPay} className='button bg-[--bgcolor] rounded-[10px]'>{t("Proceed to pay")}</button>}
                    </div>}

                </div>
            </div>}

            {iscancel && <div onClick={() => setIsCancel("")} className="model items-center">
                <div onClick={(e) => e.stopPropagation()} className="w-[350px] text-center bg-white p-[20px] rounded-[10px]">
                    <h1 className="font-[700] text-[20px]">{t("CANCEL SERVICE")}</h1>
                    <p className="leading-[19px] font-[500] text-[16px] text-gray-600">{t("Are you sure you want to canceld your service id")} #{iscancel}</p>

                    <div className="flex items-center gap-[10px] mt-[10px]">
                        <button onClick={() => setIsCancel("")} className="w-full font-[500] py-[8px] text-[17px] mt-[10px] border-[1px] rounded-[10px] ">{t("No")}</button>
                        <button onClick={handleCancleBooking} className="button bg-[--bgcolor] rounded-[10px]">
                            {apiloading
                                ? <div className="btn_loader mx-auto"></div>
                                : <span>{t("Yes")}</span>}
                        </button>
                    </div>
                </div>
            </div>}

            {isreshedule && <div onClick={() => setIsReshedule("")} className="model items-center">
                <div onClick={(e) => e.stopPropagation()} className="reshedule_box scroll_container">
                    {reshedullod
                        ? <div className="h-[500px] flex items-center justify-center">
                            <div className="loader mx-auto"></div>
                        </div>
                        : <div className="">

                            <div className="flex items-center gap-[10px] px-[20px] py-[15px] bg-white">
                                <button onClick={() => setIsReshedule("")}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M20.7501 12C20.7501 12.414 20.4141 12.75 20.0001 12.75H5.81115L8.53112 15.47C8.82412 15.763 8.82412 16.238 8.53112 16.531C8.38512 16.677 8.19309 16.751 8.00109 16.751C7.80909 16.751 7.61706 16.678 7.47106 16.531L3.47106 12.531C3.40206 12.462 3.3472 12.3791 3.3092 12.2871C3.2332 12.1041 3.2332 11.8971 3.3092 11.7141C3.3472 11.6221 3.40206 11.539 3.47106 11.47L7.47106 7.46999C7.76406 7.17699 8.2391 7.17699 8.5321 7.46999C8.8251 7.76299 8.8251 8.23803 8.5321 8.53103L5.81213 11.251H20.0001C20.4141 11.25 20.7501 11.586 20.7501 12Z" fill="#25314C"></path>
                                    </svg>
                                </button>
                                <div>
                                    <h1 className="font-[600] text-[16px]">{t("Booking")} #{isreshedule}</h1>
                                </div>
                            </div>

                            <div className="px-[20px] pt-[10px]">
                                <h1 className="font-[600] text-[17px] text-gray-600">{t("Select Date Of Service")} :</h1>
                                <div className="mt-[15px]">
                                    <div className="slider-container">
                                        <Slider {...settings}>
                                            {datelist.map((item, index) => {
                                                const IsSelected = item === selectdate;
                                                return <div key={index} onClick={() => handleSelectDate(item, copytimelist)} className={`date_box ${IsSelected && "date_selected"}`}>
                                                    <h1 className="font-[600]">{item.split(" ")[1]}</h1>
                                                    <p>{item.split(" ")[0]}</p>
                                                </div>
                                            })}
                                        </Slider>
                                    </div>
                                </div>
                            </div>

                            <div className="px-[20px] pt-[10px]">
                                <h1 className="font-[600] text-[17px] text-gray-600">{t("Select Time Of Service")} :</h1>
                                <div className="flex flex-wrap items-center gap-[15px] mt-[15px] max-_1310_:justify-center">
                                    {timelist.length >= 1
                                        ? timelist.map((item, index) => {
                                            const IsSeleted = item === selecttime;
                                            return <div key={index} onClick={() => setSelectTime(item)} className={`time_box ${IsSeleted && "time_selected"}`}>
                                                <h1 className="font-[500] ">{item}</h1>
                                            </div>
                                        })
                                        : <div className="h-[200px] bg-white w-full flex items-center justify-center rounded-[10px]">
                                            <h1 className="font-[600] text-[17px] text-gray-500">{t("No time available !!")}</h1>
                                        </div>
                                    }
                                </div>
                            </div>

                            <div className="mx-[20px]">
                                <button onClick={handleReshedule} className="button bg-[--bgcolor] rounded-[10px]">
                                    {apiloading
                                        ? <div className="btn_loader mx-auto"></div>
                                        : <span>{t("Update")}</span>}
                                </button>
                            </div>

                        </div>}
                </div>
            </div>}

            {ispayment && <div onClick={() => setIsPayment(false)} className="model items-end">
                <div onClick={(e) => e.stopPropagation()} className="bg-white w-[450px] rounded-t-[10px]">
                    <Payment totalpay={detail.add_price} BookingData={bookingdata} isshow={"2"} PageIndex={"2"} />
                </div>
            </div>}

            {isRating && <div onClick={() => setIsRating("")} className="model items-center">
                <div onClick={(e) => e.stopPropagation()} className="bg-white px-[20px] pt-[15px] pb-[15px] rounded-[16px] w-[400px]">
                    <div className="mb-[10px] flex items-center gap-[10px]">
                        <button onClick={() => setIsRating("")}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M22.0001 12C22.0001 12.552 21.5531 13 21.0001 13H5.41413L10.7071 18.293C11.0981 18.684 11.0981 19.3161 10.7071 19.7071C10.5121 19.9021 10.2561 20 10.0001 20C9.74407 20 9.48804 19.9021 9.29304 19.7071L2.29401 12.708C2.20101 12.615 2.12797 12.5051 2.07697 12.3821C1.97597 12.1381 1.97597 11.862 2.07697 11.618C2.12797 11.495 2.20101 11.385 2.29401 11.292L9.29304 4.29301C9.68403 3.90201 10.3161 3.90201 10.7071 4.29301C11.0981 4.68401 11.0981 5.31607 10.7071 5.70707L5.41413 11H21.0001C21.5531 11 22.0001 11.448 22.0001 12Z" fill="black" />
                            </svg>
                        </button>
                        <h1 className="font-[500] text-[17px]">{ratingTitle ? ratingTitle : t("Partner Rating")}</h1>
                    </div>
                    <div className="flex items-center justify-center gap-[5px] mb-[20px]">
                        {[1, 2, 3, 4, 5].map((item) => {
                            return <div key={item} onClick={(e) => { e.stopPropagation(); setOrderRating(item); }} className={`cursor-pointer ${orderrating >= item ? "text-[--bgcolor]" : "text-gray-300"}`}>
                                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.962 4.59601L14.904 8.513C15.05 8.808 15.332 9.01202 15.659 9.05902L20.1419 9.70697C20.9639 9.82597 21.292 10.834 20.697 11.412L17.456 14.557C17.219 14.787 17.111 15.118 17.167 15.443L17.9079 19.747C18.0579 20.62 17.1409 21.286 16.3549 20.875L12.467 18.84C12.175 18.687 11.827 18.687 11.536 18.84L7.65096 20.873C6.86396 21.285 5.94393 20.618 6.09493 19.743L6.83602 15.443C6.89202 15.118 6.78396 14.787 6.54696 14.557L3.30599 11.412C2.70999 10.834 3.03792 9.82597 3.86092 9.70697L8.34395 9.05902C8.66995 9.01202 8.95196 8.808 9.09896 8.513L11.041 4.59601C11.432 3.80101 12.568 3.80101 12.962 4.59601Z" fill="currentColor" />
                                </svg>
                            </div>
                        })}
                    </div>
                    <textarea value={ratingtext} onChange={(e) => setRatingText(e.target.value)} className="w-full min-h-[150px] max-h-[150px] rounded-[10px] p-[5px] border-[2px] focus-within:outline-[--bgcolor]" placeholder={t("comment...")} ></textarea>
                    <button onClick={handleRating} className="w-full mt-[15px] bg-[--bgcolor] text-white py-[8px] font-[700] text-[17px] rounded-[10px]">
                        {apiloading === "Rating"
                            ? <div className="mx-auto btn_loader"></div>
                            : t("SUBMIT")}
                    </button>
                </div>
            </div>}

        </div>
    )
}

export default MyBooking
/* jshint ignore:end */